import { render, staticRenderFns } from "./pillarItem.vue?vue&type=template&id=d4e4a58c"
import script from "./pillarItem.vue?vue&type=script&lang=js"
export * from "./pillarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports